import React, { useEffect } from 'react';
import get from 'lodash/get';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons/faPencilAlt';

import Header from '../../layout/Header.jsx';
import useHttpStatus from '~/commons/hooks/useHttpStatus';
import PageHttp from '~/commons/components/PageHttp.jsx';

import { env } from '../../../config';

const PageSchDashBoard = () => {
  const [res, req] = useHttpStatus();
  const { i18n: { language } } = useTranslation();
  const lang = language === 'en' ? 'en' : 'zhhk';

  useEffect(() => {
    req({
      url: '/api/core/users/self',
    });
  }, []);
  const { t } = useTranslation();

  return (
    <PageHttp res={res}>
      {(user) => {
        const userInfo = [
          { label: 'Name (Chinese)', v: get(user, 'name.full.zhhk') },
          { label: 'Name (English)', v: get(user, 'name.full.en') },
          { label: 'Email', v: get(user, 'email') },
        ].filter((({ v }) => v));

        const schInfo = [
          { label: 'School (Chinese)', v: get(user, 'school.title.zhhk') },
          { label: 'School (English)', v: get(user, 'school.title.en') },
          {
            label: 'District',
            v: env.districts[user.school.district][lang],
          },
          {
            label: 'Stage',
            v: {
              p: { en: 'Primary', zhhk: '小學' },
              s: { en: 'Secondary', zhhk: '中學' },
            }[user.school.stage][lang],
          },
        ].filter((({ v }) => v));

        return (
          <>
            <Header>
              {user.school.title.zhhk || user.school.title.en}
            </Header>
            <div className="card p-4">
              <div className="row align-items-center">
                <div className="col">
                  {userInfo.map((a, i) => (
                    <div className="row" key={i}>
                      <div className="col-4">
                        <strong>{t(a.label)}</strong>
                      </div>
                      <div className="col">
                        {a.v}
                      </div>
                    </div>
                  ))}
                  <hr/>
                  {schInfo.map((a, i) => (
                    <div className="row" key={i}>
                      <div className="col-4">
                        <strong>{t(a.label)}</strong>
                      </div>
                      <div className="col">
                        {a.v}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </>
        );
      }}
    </PageHttp>
  );
};

export default PageSchDashBoard;
